"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchMatrix = void 0;
const lodash_1 = require("lodash");
function matchMatrix(bools, matrixTable) {
    const columnHeight = bools.length;
    const rowWidth = columnHeight + 1;
    const expectedMatrixTableSize = columnHeight * rowWidth * 2;
    const actualMatrixTableSize = matrixTable.length;
    if (expectedMatrixTableSize !== actualMatrixTableSize) {
        const msg = `matrix table wrong size! n=${columnHeight}, expected ${expectedMatrixTableSize}, got ${actualMatrixTableSize}.`;
        throw new Error(msg);
    }
    const rows = lodash_1.chunk(matrixTable, rowWidth);
    for (const row of rows) {
        let success = true;
        let i;
        for (i = 0; i < row.length - 1; i++) {
            if (bools[i] !== row[i]) {
                success = false;
                break;
            }
        }
        if (success) {
            return !!row[i];
        }
    }
    throw new Error(`checked whole matrix table, did not find a match - impossible.`);
}
exports.matchMatrix = matchMatrix;
//# sourceMappingURL=matchMatrix.js.map